module.exports = __webpack_public_path__ + "static/media/management_slider_phone2.31501369.png";